import store from '@/store'
import { header } from "./header"
// 获取数据字典
export function getDictInfo(code) {
    const arr = store.state.global.dictItem
    if (arr && arr.length) {
        const rows = arr.find(item => item.zdbm === code)
        if (rows) return rows.children
    }
    return []
}

export const extractTextFromHTML = function (html) {
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;

    // 递归遍历节点并提取文本
    function extractText(node, result) {
        if (node.nodeType === Node.TEXT_NODE) {
            result.push(node.textContent.trim());
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            for (let childNode of node.childNodes) {
                extractText(childNode, result);
            }
        }
    }

    const textNodes = [];
    extractText(tempElement, textNodes);

    return textNodes.join('');
}

// 图片地址拼接
export const concatImg = function (url) {
    if (!url) return ''
    if (url.indexOf('http') !== -1) return url + '?yghtb=true'
    return store.state.global.baseUrl + url + '?yghtb=true'
}
export const sleep = async function (ms) {
    await new Promise(resolve => setTimeout(resolve, ms));
}
// 过滤
export const onFilterDict = function (arr, key = "zdmc", value = "zdbm") {
    return arr.map((item) => {
        return {
            ...item,
            label: item[key],
            value: item[value],
        };
    });
}
// 全局baseUrl
export const concatUrl = store.state.global.baseUrl

// 获取图片的宽高比
export const getImageRatio = function (imageUrl) {
    const image = new Image();
    image.src = imageUrl;
    return image.naturalWidth / image.naturalHeight;
}
// 按图片比例通过高度获取宽度
export const getImageWidthByRatio = function (imageUrl, height) {
    console.log(getImageRatio(imageUrl), 111)
    return getImageRatio(imageUrl) * height
}
// 按图片比例通过宽度获取高度
export const getImageHeightByRatio = function (imageUrl, wdith) {
    return wdith / getImageRatio(imageUrl)
}


//获取头部数据
export const getHeaderData = function (id) {
    const headerlist = header
    for (let index = 0; index < headerlist.length; index++) {
        const item = headerlist[index];
        if (id == item.id) {
            return item
        }
    }
    return null
}


/**

* 这里用到Promise.all
判断所有图片加载完毕
*/
export const onAllImgLoaded = async () => {
    const imgNodes = document.querySelectorAll('img');
    //为了使用Array的map方法
    let imgArr = Array.prototype.slice.call(imgNodes);
    return await Promise.all(
        imgArr.map(img => {

            new Promise(resolve => {
                img.addEventListener('load', () => {
                    resolve(1)
                })
            })
        })
    )
}
